var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SchoolReserveRecord"},[_c('ReserveRecord',{attrs:{"props-data":{subscribeType: 1, getCode: _vm.getCode}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }